import React from "react"
import { Navigate, useParams } from "react-router-dom"

const RedirectLegacyPublicReserve: React.FC = () => {
  const { slug } = useParams()

  return <Navigate to={`/v/${slug}`} replace />
}

export default RedirectLegacyPublicReserve
